'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AddItemsToTopCheckbox = require('./components/AddItemsToTopCheckbox.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AddItemsToTopCheckbox).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/add-items-to-top-checkbox/index.js
// module id = 1272
// module chunks = 0